import AppRoot from './AppRoot';

export default AppRoot;
